import React from 'react';
import { Keyboard, LayoutAnimation, TouchableOpacity } from 'react-native';
import { Footer, Content, Text, View, Left, Right, Body, Button, Title, Icon, Container } from 'native-base';
import Modal from './modal';

import styles from './formFooter.styles';
import * as _ from 'lodash';

import Calculator from './calculator';

class FormFooter extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			showFooter: false,
			isCalcVisible: false,
			calcValue: 0,
			prevEditIndex: null,
			fieldLabel: null
		};
		this.state = this.initialState;
	}
	componentDidMount() {
		this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow.bind(this));
		this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide.bind(this));
	}

	componentWillUnmount() {
		this.keyboardDidShowListener.remove();
		this.keyboardDidHideListener.remove();
	}
	_keyboardDidShow() {
		LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
		this.setState({ showFooter: true });
	}

	_keyboardDidHide() {
		LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
		this.setState({ showFooter: false });
	}

	findCurrentFormRef() {
		if (!this.props.formRefs) return -1;
		return _.findIndex(this.props.formRefs, function(o) {
			return o && o.getRenderedComponent().props.meta.active;
		});
	}

	nextField() {
		const curr = this.findCurrentFormRef();
		if (this.props.formRefs[curr + 1]) {
			this.props.formRefs[curr + 1].getRenderedComponent().refs.input._root.focus();
		} else {
			Keyboard.dismiss();
		}
	}

	prevField() {
		const curr = this.findCurrentFormRef();

		if (this.props.formRefs[curr - 1]) this.props.formRefs[curr - 1].getRenderedComponent().refs.input._root.focus();
		if (curr - 1 == 0) Keyboard.dismiss();
	}

	onCalcValue(val) {
		const input = this.props.formRefs[this.state.prevEditIndex];
		if (input) {
			this.props.updateVal(input.props.name, val.toFixed(2));
			input.getRenderedComponent().refs.input._root.focus();
			this.setState({ isCalcVisible: false });
			setTimeout(this.nextField.bind(this), 800); //this is horrible, but we have no other way to trigger the asyncValidation other than blurring. And we don't know when the updateVal dispatch has done
		}
	}

	showCalc() {
		const curr = this.findCurrentFormRef();
		const val = this.props.formRefs[curr] && this.props.formRefs[curr].value;
		__DEV__ && console.log(this.props.formRefs[curr]);
		Keyboard.dismiss();
		this.setState({ isCalcVisible: true, calcValue: val ? val : 0, fieldLabel: this.props.formRefs[curr].props.label, prevEditIndex: curr });
	}

	render() {
		//console.log('formRefs: ',this.props.formRefs);
		//are we on a formRef field?
		//const currRef = this.state.showFooter && this.findCurrentFormRef();
		//console.log(currRef);
		const showCalcBtn = true;

		return this.state.showFooter && !this.state.isCalcVisible ? (
			<Footer style={styles.footer}>
				<Left>
					<Button style={styles.bottomButton} onPress={this.prevField.bind(this)}>
						<Icon name="skip-backward" style={styles.bottomIcon} />
					</Button>
				</Left>
				<Body>
					{showCalcBtn ? (
						<Button style={styles.bottomButton} onPress={() => this.showCalc()}>
							<Icon name="calculator" style={styles.bottomIcon} />
						</Button>
					) : (
						undefined
					)}
				</Body>
				<Right>
					<Button style={styles.bottomButton} onPress={this.nextField.bind(this)}>
						<Icon name="skip-forward" style={styles.bottomIcon} />
					</Button>
				</Right>
			</Footer>
		) : (
			<Modal
				animationIn="slideInDown"
				animationOut="slideOutDown"
				backdropColor="#295670"
				backdropPressToClose
				backButtonClose
				coverScreen
				style={styles.modalStyle}
				swipeThreshold={100}
				isOpen={this.state.isCalcVisible}
				onClosed={() => this.setState({ isCalcVisible: false })}
				swipeDirection="down">
				<Calculator onSave={this.onCalcValue.bind(this)} initVal={this.state.calcValue} label={this.state.fieldLabel} />
			</Modal>
		);
	}
}

export default FormFooter;
